import React, {useState} from 'react'
import {KTSVG} from '../../../../../../../template/_metronic/helpers'
import 'flatpickr/dist/flatpickr.css'
import Flatpickr from 'react-flatpickr'
import CustomDateInput from '../../../../../../../helpers/elements/inputs/CustomDateInput'
import {useDispatch, useSelector} from 'react-redux'
import {setCompletedBatchFilter} from '../../../../../../../redux/slices/completedBatchFilterSlice'
import {RootState} from '../../../../../../../redux/store'

const HistoryFilters = () => {
  const currentCompletedBatchFilter = useSelector(
    (state: RootState) => state.completedBatchFilterSlice
  )
  const [search, setSearch] = useState('')
  const [startDate, setStartDate] = useState<Date>(new Date(currentCompletedBatchFilter.startDate || ''))
  const [endDate, setEndDate] = useState<Date>(new Date(currentCompletedBatchFilter.startDate || ''))

  const dispatch = useDispatch()

  const handleClickFilter = () => {
    dispatch(
      setCompletedBatchFilter({
        ...currentCompletedBatchFilter,
        searchTerm: search,
        startDate: startDate.toString(),
        endDate: endDate.toString(),
        page: 1,
      })
    )
  }

  return (
    <div className='card-header border-0 d-flex'>
      <div className='d-flex flex-wrap gap-7'>
        <div className='d-flex'>
          <div className='fv-row'>
            <label className='fw-semibold text-gray fs-3 mb-4'>Buscar</label>
            <div className='d-flex align-items-center position-relative'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-5 text-primary pe-4 border-1 border-end border-primary border-opacity-25'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-custom ps-20'
                placeholder='Buscar'
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value)
                }}
              />
            </div>
          </div>
        </div>

        <div className='d-flex'>
          <div className='fv-row'>
            <label className='fw-semibold text-gray fs-3 mb-4'>Desde</label>
            <Flatpickr
              options={{enableTime: false, dateFormat: 'd, M, Y', disableMobile: true}}
              render={({defaultValue, value, ...props}, ref) => {
                return (
                  <CustomDateInput
                    ref={ref}
                    className='bg-white fs-2 text-primary-dark me-10'
                    placeholder={'Seleccionar fecha'}
                  />
                )
              }}
              onChange={([date]) => {
                setStartDate(date)
              }}
              value={startDate}
            />
          </div>

          <div className='fv-row'>
            <label className='fw-semibold text-gray fs-3 mb-4'>Hasta</label>
            <Flatpickr
              options={{enableTime: false, dateFormat: 'd, M, Y', disableMobile: true}}
              render={({defaultValue, value, ...props}, ref) => {
                return (
                  <CustomDateInput
                    ref={ref}
                    className='bg-white fs-2 text-primary-dark'
                    placeholder={'Seleccionar fecha'}
                  />
                )
              }}
              onChange={([date]) => {
                setEndDate(date)
              }}
              value={endDate}
            />
          </div>
        </div>
        <div className='d-flex align-items-end'>
          <button className='btn btn-primary' onClick={handleClickFilter}>
            Filtrar
          </button>
        </div>
      </div>
    </div>
  )
}

export {HistoryFilters}
